import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from '../CommonComponents/Highcharts';
import LoadingChart from '../CommonComponents/LoadingChart';

class DebtManagementChartView extends Component {
  componentDidMount() {
    const { hasChartData, dataIsOutdated, isPrint } = this.props;

    if ((!hasChartData || dataIsOutdated) && !isPrint) {
      const { clientId, fpId, getChartData, goalId, isPdf } = this.props;
      getChartData(fpId, clientId, isPdf, goalId);
    }
  }

  componentWillUnmount() {
    this.props.resetState();
  }

  render() {
    const {
      isPrint,
      chartData,
      hasLoaded,
      showLabel,
      showTitle,
      chartTitle,
      selectedPlanName,
      currentPlanName,
      isCurrent,
      noContainer,
    } = this.props;

    const Chart = () => (
      <ReactHighcharts
        autoResize
        className={
          isPrint ? 'debtManagement-chart-container-print' : 'debtManagement-chart-container'
        }
        container="DebtManagementChart"
        options={chartData}
      />
    );

    if (noContainer) {
      if (!hasLoaded) {
        return <LoadingChart />;
      }
      return (
        <section className="NewFinancialPlan_DebtManagementProgressChart">
          <Chart />
        </section>
      );
    }

    return (
      <section
        className="
        debtManagement-chart-component
        chart"
      >
        <div
          className="
          NewFinancialPlan_ProgressChart
          NewFinancialPlan_DebtManagementProgressChart"
        >
          {showTitle && (
            <h2>
              <span className="title">{chartTitle}</span>
            </h2>
          )}
          <div
            className="
            chart
            NewFinancialPlan_DebtManagementProgressChart_BarChart"
          >
            {showLabel && (
              <ul className="legend">
                <li>
                  <i className="current-plan-name" />
                  {currentPlanName}
                </li>
                {!isCurrent && (
                  <li>
                    <i className={`proposed-plan-name ${isPrint ? 'isPrint' : ''}`} />
                    {selectedPlanName}
                  </li>
                )}
              </ul>
            )}
            {!hasLoaded && <LoadingChart />}
            {hasLoaded && <Chart />}
          </div>
        </div>
      </section>
    );
  }
}

DebtManagementChartView.defaultProps = {
  chartTitle: '',
  isPdf: false,
  isPrint: false,
  showLabel: true,
  showTitle: true,
  noContainer: false,
};

DebtManagementChartView.propTypes = {
  isCurrent: PropTypes.bool.isRequired,
  chartData: PropTypes.shape({}).isRequired,
  chartTitle: PropTypes.string,
  currentPlanName: PropTypes.string.isRequired,
  selectedPlanName: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  dataIsOutdated: PropTypes.bool.isRequired,
  fpId: PropTypes.string.isRequired,
  getChartData: PropTypes.func.isRequired,
  goalId: PropTypes.string.isRequired,
  hasChartData: PropTypes.bool.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  isPdf: PropTypes.bool,
  isPrint: PropTypes.bool,
  showLabel: PropTypes.bool,
  showTitle: PropTypes.bool,
  noContainer: PropTypes.bool,
  resetState: PropTypes.func.isRequired,
};

export default DebtManagementChartView;
